// var discountPrice = document.querySelector('.discount-amount');
// var discountPercentage = document.querySelector('.discount-percentage');
// discountPrice.innerHTML = theme.Currency.formatMoney(variant.compare_at_price - variant.price, theme.moneyFormat);
// discountPercentage.innerHTML =
//   (((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price).toFixed() + '%';

//  invoice
document.addEventListener('DOMContentLoaded', function () {
  const invoiceCheckbox = document.getElementById('invoice_toggle_checkbox');
  const invoiceContent = document.querySelector('.invoice-toggle__content');
  const checkoutButton = document.getElementById('CheckOut');

  if (invoiceCheckbox && invoiceContent) {
    // Get all input fields inside the invoice toggle
    const invoiceInputs = invoiceContent.querySelectorAll('input[type="text"]');
    const companyVat = document.getElementById('company_vat');
    const companyEik = document.getElementById('company_eik');

    // Function to validate invoice fields
    function validateInvoiceFields() {
      if (!invoiceCheckbox.checked) {
        return true; // If checkbox is not checked, validation passes
      }

      // Check if at least one of VAT or EIK is filled
      const hasVat = companyVat && companyVat.value.trim();
      const hasEik = companyEik && companyEik.value.trim();

      if (!hasVat && !hasEik) {
        return false; // Both VAT and EIK are empty
      }

      // Check if all other required fields are filled (excluding VAT and EIK)
      for (let input of invoiceInputs) {
        if (input.id !== 'company_vat' && input.id !== 'company_eik') {
          if (!input.value.trim()) {
            return false; // If any other field is empty, validation fails
          }
        }
      }
      return true; // At least one of VAT/EIK is filled and all other fields are filled
    }

    // Function to update checkout button state
    function updateCheckoutButton() {
      if (checkoutButton) {
        const isValid = validateInvoiceFields();
        checkoutButton.disabled = !isValid;

        if (!isValid) {
          checkoutButton.style.opacity = '0.5';
          checkoutButton.style.cursor = 'not-allowed';
          checkoutButton.title = 'Please fill all invoice fields (VAT or EIK required)';
        } else {
          checkoutButton.style.opacity = '1';
          checkoutButton.style.cursor = 'pointer';
          checkoutButton.title = '';
        }
      }
    }

    // Function to update required attributes
    function updateRequiredAttributes() {
      invoiceInputs.forEach((input) => {
        if (invoiceCheckbox.checked) {
          // Make all fields required except VAT and EIK (they're conditionally required)
          if (input.id !== 'company_vat' && input.id !== 'company_eik') {
            input.setAttribute('required', 'required');
          }
        } else {
          input.removeAttribute('required');
        }
      });
    }

    // Toggle content visibility and update validation
    invoiceCheckbox.addEventListener('change', function () {
      updateRequiredAttributes();
      updateCheckoutButton();
    });

    // Add event listeners to all invoice inputs
    invoiceInputs.forEach((input) => {
      input.addEventListener('input', updateCheckoutButton);
      input.addEventListener('blur', updateCheckoutButton);
    });

    // Initial validation
    updateCheckoutButton();
  }
});
